/*
 * @Author: WGL 958897276@qq.com
 * @Date: 2024-12-25 15:30:02
 * @LastEditors: WGL 958897276@qq.com
 * @LastEditTime: 2025-05-13 15:01:28
 * @FilePath: /erp-admin/src/api/notice.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { getRequest, postRequest } from './api'

const module = 'message'
export function getNoticeList(params = {}) {
  const url = `${module}/index`
  return getRequest(url, params)
}

export function addNotice(params = {}) {
  const url = `${module}/add`
  return postRequest(url, params)
}

export function editNotice(params = {}) {
  const url = `${module}/edit`
  return postRequest(url, params)
}

export function detailNotice(params = {}) {
  const url = `${module}/detail`
  return getRequest(url, params)
}

export function deleteNotice(params = {}) {
  const url = `${module}/delete`
  return postRequest(url, params)
}

export function readNotice(params = {}) {
  const url = `${module}/read`
  return postRequest(url, params)
}

export function readAllNotice(params = {}) {
  const url = `${module}/readAll`
  return postRequest(url, params)
}

export function getTypeNotice(params = {}) {
  console.log(params)
  // const url = `${module}/getTypeTree`
  // return getRequest(url, params)
}
export function getUnreadTotal(params = {}) {
  console.log(params)
  const url = `${module}/getUnreadTotal`
  return getRequest(url, params)
}
